export const claRoutesMap = {
  iataAerolineas: {
    name: 'Iata Aerolineas',
    path: '/clasificadores/iata-aerolineas',
  },
  agenciaViajes: {
    name: 'Agencia de Viajes',
    path: '/clasificadores/agencia-de-viaje',
  },
  origenServicio: {
    name: 'Origen Servicios',
    path: '/clasificadores/origen-servicios',
  },
  tipoTransaccion: {
    name: 'Tipo Transacción',
    path: '/clasificadores/tipo-transaccion',
  },
}
